import PropTypes from 'prop-types';
import {Translate, I18n} from 'react-redux-i18n';
import {EntityIllustration, OperaStatus, Icon, ThreeDotsMenu, MenuCommand, Button} from 'front-onceforall-core';
import {Tooltip} from '@material-ui/core';
import DossierStateCell from '../../dossier/DossierStateCell';
import authenticationService from '../../../services/authentication/AuthenticationService';
import {ACTRADIS_MASTER_PLATFORM} from '../../../utils/constant';
import {getOrganisationLogoUrl} from '../../../utils/organisation';
import {TYPES} from '../utils/utils';

function ListItemView(props) {
  const roles = authenticationService.roles();
  const isConsultant = roles.isConsultant();
  const isExplorer = roles.isExplorer();
  const showActions = !isConsultant && !isExplorer;
  const {organisation} = props;

  function handleReinviteOrganisation() {
    const event = new CustomEvent('reinviteSubcontractor', {detail: organisation});
    window.dispatchEvent(event);
  }

  return (
    <tr>
      <td
        data-id="fullName"
        className="clickable"
        onClick={event => props.onClickOrganisation(event, organisation.organisationId)}
      >
        <div className="flex-container center">
          <EntityIllustration
            imageUrl={getOrganisationLogoUrl(organisation.organisationId)}
            country={organisation.country}
            name={organisation.fullName}
            small
          />
          <span className="ml-3">{organisation.fullName} </span>
          {props.type === TYPES.SUBCONTRACTOR &&
            <OperaStatus
              organisation={organisation}
              small
              masterPlatformToShow={ACTRADIS_MASTER_PLATFORM}
            />
          }
          {organisation.favorite &&
            <span className="warning ml-3">
              <Icon
                icon="star-full"
                size={22}
              />
            </span>
          }
        </div>
      </td>
      <td>
        {!organisation.enabled &&
          <span
            data-id="deactivated-organisation"
            className="information"
          >
            <Translate value="organisation.deactivated.title"/>
          </span>
        }
      </td>
      <td data-id="registrationNumber">{organisation.registrationNumber}</td>
      <td data-id="postCode">{organisation.address.postCode}</td>
      <td data-id="city">{organisation.address.city}</td>
      <td data-id="country"><Translate value={`country.${organisation.country}`}/></td>
      {props.type === TYPES.SUBCONTRACTOR &&
        <DossierStateCell
          data-id="dossierState"
          state={props.dossierState}
        />
      }
      <td data-id="actions">
        <div className="inline-container flex-end">
          {props.type === TYPES.SUBCONTRACTOR && !organisation.depositor &&
            <Tooltip title={<Translate value="subcontractor.reinvite.tooltip"/>}>
              <span>
                <Button
                  icon="redo"
                  onClick={handleReinviteOrganisation}
                >
                  {I18n.t('subcontractor.reinvite.action')}
                </Button>
              </span>
            </Tooltip>
          }
          {showActions &&
            <ThreeDotsMenu
              data-id="organisation-actions"
              onOpen={() => props.onMenuBtnClick(organisation.organisationId)}
            >
              <MenuCommand
                data-id="organisation-actions-delete"
                onClick={() => props.onDeleteOrganisation(organisation)}
                label={<Translate value="organisation.delete.title"/>}
                disabled={props.hasInterventionInProject === null || props.hasInterventionInProject}
                disabledMessage={props.hasInterventionInProject ? I18n.t('organisation.delete.tooltip') : ''}
                icon={props.hasInterventionInProject === null ? 'loader' : 'trash'}
              />
            </ThreeDotsMenu>
          }
        </div>
      </td>
    </tr>
  );
}

ListItemView.propTypes = {
  organisation: PropTypes.object.isRequired,
  type: PropTypes.oneOf(Object.values(TYPES)).isRequired,
  hasInterventionInProject: PropTypes.bool,
  onMenuBtnClick: PropTypes.func.isRequired,
  onDeleteOrganisation: PropTypes.func.isRequired,
  onClickOrganisation: PropTypes.func.isRequired,
  dossierState: PropTypes.string
};

export default ListItemView;
